import config from "../config/config";
import { getToken } from "../utils/prefix";

export async function category_create(data) {
  const res = await fetch(config.api_backend + `/category/create`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function category_update(data) {
  const res = await fetch(config.api_backend + `/category/update`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function category_taskCreate(data) {
  const res = await fetch(config.api_backend + `/category/createtask`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function category_delete(data) {
  const res = await fetch(config.api_backend + `/category/delete`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_all_category(data) {
  const res = await fetch(config.api_backend + `/category/all`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_suggest_category(data) {
  const res = await fetch(config.api_backend + `/category/suggestion`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      // Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function get_category(data) {
  const res = await fetch(config.api_backend + `/category/getCategoryById`, {
    body: JSON.stringify(data),
    method: "POST",
    headers: {
      //   Authorization: getToken(),
      "Content-type": "application/json",
    },
  });

  const dataRespone = await res.json();
  return dataRespone;
}

export async function save_category_img(data) {
  var formdata = new FormData();
  formdata.append("category_id", data.category_id);
  formdata.append("user_id", data.user_id);
  formdata.append("file", data.file);
  const res = await fetch(
    config.api_backend + `/category/uploadCategoryImgFile`,
    {
      body: formdata,
      method: "POST",
      headers: {
        "x-access-token": getToken(),
      },
    }
  );

  const dataRespone = await res.json();
  return dataRespone;
}
